import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';

// Подавляем ошибку ResizeObserver, которая не критична для функциональности
// Эта ошибка часто возникает в React 18 Strict Mode с модальными окнами и таблицами
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (e.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
      e.message?.includes('ResizeObserver loop limit exceeded') ||
      e.message?.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
  return true;
};

window.addEventListener('error', resizeObserverErrorHandler);

// Также обрабатываем необработанные промисы
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
      e.reason?.message?.includes('ResizeObserver loop limit exceeded') ||
      e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

// Дополнительная защита через console.error override (только для ResizeObserver)
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  if (message.includes('ResizeObserver loop completed with undelivered notifications') ||
      message.includes('ResizeObserver loop limit exceeded') ||
      message.includes('ResizeObserver')) {
    // Подавляем только ResizeObserver ошибки, остальные выводим
    return;
  }
  originalConsoleError.apply(console, args);
};

// Дополнительная защита через глобальный обработчик ошибок
const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return true; // Подавляем ошибку
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Отключаем логирование ошибок в консоль для мутаций
      // Ошибки будут обрабатываться в onError каждого useMutation
      onError: () => {
        // Пустая функция, чтобы предотвратить логирование в консоль
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
